<template>
  <div class="sub-tarefa-inputs-pai">
    <div class="sub-tarefa-inputs">
      <div class="sub-tarefa-inputs-top">
        <h6>AVISO</h6>
        <h6
          style="cursor: pointer"
          @click="fecharModal()"
        >
          X
        </h6>
      </div>

      <div class="sub-tarefa-all-inputs">
        <div class="btns">
          <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-if="sucesso == true"
          >
            <i
              class="fa-solid fa-circle-check fa-5x"
              style="color: #27d41b"
            ></i>
            <h4>{{ texto }}</h4>
          </div>

          <div
            class="subTarefa-titulo-input subTarefa-titulo-input-aviso"
            v-else
          >
            <i
              class="fa-sharp fa-solid fa-circle-exclamation fa-5x"
              style="color: #ff0000"
            ></i>
            <h4>{{ texto }}</h4>
          </div>
        </div>
        <div
          v-if="mostrarBotoesLogin"
          class="modal-botoes"
        >
          <button
            class="btn-voltar"
            @click="fecharModal()"
          >
            Voltar
          </button>

          <button
            class="btn-login"
            @click="irParaLogin()"
          >
            Login
          </button>
        </div>

        <button
          v-else
          class="btn-ok"
          @click="fecharModal()"
        >
          OK
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  sucesso: Boolean,
  texto: String,

  mostrarBotoesLogin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["fecharModal", "login"]);

function fecharModal() {
  emit("fecharModal");
}

function irParaLogin() {
  emit("login");
}
</script>

<style scoped>
.sub-tarefa-inputs-pai {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.sub-tarefa-inputs {
  background-color: #ffffff;
  border: none;
  border-radius: 12px;
  width: 430px;
  max-width: 90vw;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sub-tarefa-inputs-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background-color: #3a2474;
  padding: 12px 0;
  position: relative;
  min-height: 46px;
}

.sub-tarefa-inputs-top h6:first-child {
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  margin: 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.sub-tarefa-inputs-top h6:last-child {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 14px;
  background-color: #3a2474;
  color: #ffffff;
  margin: 0;
  cursor: pointer;
  font-weight: bold;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border-radius: 0 12px 0 0;
  min-width: 38px;
}

.sub-tarefa-inputs-top h6:last-child:hover {
  background-color: #2e1a5e;
}

.sub-tarefa-all-inputs {
  padding: 32px 24px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.subTarefa-titulo-input-aviso {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 18px;
}

.subTarefa-titulo-input-aviso h4 {
  font-size: 16px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  text-align: center;
}

/* Botão OK original */
.btn-ok {
  background-color: #7c3aed;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 9px 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: background-color 0.15s ease;
}

.btn-ok:hover {
  background-color: #6d28d9;
}
/* Novos botões */
.modal-botoes {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.modal-botoes button {
  border: none;
  border-radius: 8px;
  padding: 9px 30px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.3px;
  transition: background-color 0.15s ease;
}

.btn-voltar {
  background-color: #e5e5e5;
  color: #333333;
}

.btn-voltar:hover {
  background-color: #d5d5d5;
}

.btn-login {
  background-color: #7c3aed;
  color: #ffffff;
}

.btn-login:hover {
  background-color: #6d28d9;
}

.btn-login:hover {
  background-color: #6d28d9;
}
</style>
